import React from 'react';
import { ImageViewer } from '@/components/ui/image-viewer/ImageViewer';
import { useImageViewerActions, useImageViewerState } from '@/components/ui/image-viewer/ImageViewerProvider';

export const ImageViewerWrapper: React.FC = () => {
  const { hideImage } = useImageViewerActions();
  const {
    isVisible,
    currentUri,
    currentPhoto,
    currentPhotos,
    thumbnailLayout,
    isClosingDueToNavigation,
    loadError,
    allowImageDownload,
    disableSocialActions,
  } = useImageViewerState();

  return (
    <ImageViewer
      visible={isVisible}
      uri={currentUri}
      photo={currentPhoto}
      photos={currentPhotos ?? undefined}
      thumbnailLayout={thumbnailLayout}
      onClose={hideImage}
      isClosingDueToNavigation={isClosingDueToNavigation}
      loadError={loadError}
      allowImageDownload={allowImageDownload}
      disableSocialActions={disableSocialActions}
    />
  );
};
